import {
  NavigationMenu,
  NavigationMenuList,
} from '@/components/ui/navigation-menu';
import { BenachrichtigungenItem } from '@/domain/navigation/benachrichtigungen/components/BenachrichtigungenItem';
import {
  HomeItem,
  ProfileItemDropdown,
  useMenuItems,
} from '@/domain/navigation/features/navigation/desktop';
import { MobileMenuItem } from '@/domain/navigation/features/navigation/mobile';
import { Search } from '@/domain/navigation/features/search';

export function Navigation() {
  const menuItems = useMenuItems();

  return (
    <div className="w-full bg-white border-b-miscellaneous-separator-nonOpaque border-b">
      <div className="flex items-center justify-between px-10 py-2 h-16">
        <div className="flex items-center gap-4">
          <HomeItem />
          <div className="hidden sm:flex w-px h-8 bg-neutrals-300" />
          <NavigationMenu className="hidden sm:flex">
            <NavigationMenuList className="gap-3">
              {menuItems}
            </NavigationMenuList>
          </NavigationMenu>
        </div>
        <div className="flex items-center gap-3">
          <Search />
          <BenachrichtigungenItem />
          <ProfileItemDropdown className="hidden sm:flex" />
          <MobileMenuItem />
        </div>
      </div>
    </div>
  );
}
